module.exports = __webpack_public_path__ + "static/media/banner1.e2d0fc97.jpg";